import { Component, inject,OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '../../environments/environment';
import { Customer, CustomerList } from '../../models/customer';
import { CustomerService } from '../../services/customer.service';
import { VerticalSelectorService } from '../../services/vertical-selector.service';
import { setStorageObject } from '../../utils/storage-manager';
import { securityDomain, securityDomainUS } from '../main/main.component';

@Component({
  selector: 'app-vertical-selector',
  templateUrl: './vertical-selector.component.html',
  styleUrls: ['./vertical-selector.component.scss']
})
export class VerticalSelectorComponent implements OnInit {
  private customerService = inject(CustomerService);
  protected customerList = new CustomerList();
  private router = inject(Router);
  private verticalSelectorService = inject(VerticalSelectorService);
  private translateService = inject(TranslateService);

  ngOnInit(): void {
    this.customerService.listCustomers().subscribe((list) => {
      this.customerList = list;
      const securityIndex = this.customerList.items.findIndex((x) => x.domain === securityDomain);
      const securityIndexUS = this.customerList.items.findIndex((x) => x.domain === securityDomainUS);
      if (securityIndex != -1) {
        this.customerList.items[securityIndex] = new Customer(
          securityDomain,
          this.translateService.instant('announcements.plural') + ' ' +
          this.translateService.instant('announcements.region.EU'),
          'assets/global/'
        );
        if (environment.regionsAvailables.includes('US')) {
          this.customerList.items[securityIndexUS] = new Customer(
            securityDomainUS,
            this.translateService.instant('announcements.plural') + ' ' +
            this.translateService.instant('announcements.region.US'),
            'assets/global/'
          );
        }
      }
    });
  }

  setVerticalAndGoLogin(customer: Customer | null): void {
    this.verticalSelectorService.setVertical(customer);
    this.router.navigateByUrl('login');
    setStorageObject('region', customer?.domain === 'us-security' ? ['US'] : ['EU']);
  }
}
